<template>
    <div class="mx-auto">
        <b-modal
                ref="modal-honorarios-ef-sefa"
                id="modal-honorarios-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="'Requisição n. ' + itemCarregado.numeroRequisicao"
                header-bg-variant="success"
                header-text-variant="white"
                @hidden="close">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ 'Requisição n. ' + itemCarregado.numeroRequisicao }}</h5>
                <b-button variant="success" @click="relatorioPDF" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
            </template>
            <b-row>
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <CompFiltroGrid
                                ref="compFiltro"
                                :filtro="filtro"
                                compId="popupExtrato"
                                @filtrarResultados="filtrarResultados"
                                @ordenarResultados="ordenarResultados"/>

                        <b-tabs card active-nav-item-class="text-title-selected" v-model="tabIndex">
                            <b-tab title="Dados Básicos" active title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Tipo da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ requisicaoEfSefa.tipoRequisicao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Data de Criação:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.dataCriacao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Status Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p :style="'color: ' + requisicaoEfSefa.corStatus">{{ requisicaoEfSefa.status }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Forma de Pgto.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.formaPagamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Tipo de Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.tipoPagamento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modalidade Parc.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.modalidadeParcelamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Qtde. Parcelas:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p v-if="requisicaoEfSefa.tipoPagamento != 'À Vista'">{{ requisicaoEfSefa.quantidadeParcelas }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Vlr. da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>R$ {{ requisicaoEfSefa.valor | currency }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Percentual Pago:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.percentualPago }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Origem Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.origem }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Índice de Reajuste:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.indiceReajuste }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Setor Emitente:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.setor }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>REFIS:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.refis }}</p>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Observações:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <pre><p class="texto-scroll" v-html="requisicaoEfSefa.observacoes"></p></pre>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="3" md="2">
                                        <label>Docs. Anexados:</label>
                                    </b-col>
                                    <b-col sm="6" md="7">
                                        <span v-for="anexo in requisicaoEfSefa.anexos" :key="anexo.codAnexo">
                                        <p>
                                            <a class="link" @click="obterAnexo(anexo)">
                                                {{ anexo.nomeAnexo }}
                                            </a>
                                            <b-button class="ml-2" v-if="perfilAdministrador"
                                                    variant="outline-warning"
                                                    @click="removerAnexo(anexo)">
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </p>
                                        </span>
                                    </b-col>
                                    <b-col sm="3" md="3">
                                        <b-button variant="outline-warning" @click="incluirAnexo" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
                                        <b-form-file v-show="false" @input="realizarUpload" ref="incluir-anexo"></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Devedor" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Devedor:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.nome }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>CPF/ CNPJ:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.documento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>E-mail principal:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.email }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Celular:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.telefone }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Endereço:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.logradouro }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Nº:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.numero }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Complemento:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ requisicaoEfSefa.contribuinte.complemento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Cidade:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.municipio != null ? requisicaoEfSefa.contribuinte.municipio.nome : '' }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Estado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.uf != null ? requisicaoEfSefa.contribuinte.uf.nome : '' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>CEP:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.contribuinte.cep }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="12">
                                        <b-button variant="outline-primary" style="float: right;" @click="atualizarCadastro">
                                            <i class="far fa-address-book fa-flip-horizontal icon-button align-middle"></i> Abrir Cadastro do Devedor
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Cálculo" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Base de Cálculo:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.baseCalculo }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Base:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.valorBase }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Percentual:</label>
                                    </b-col>
                                    <b-col sm="6" md="4" >
                                        <p v-if="!requisicaoEfSefa.boletoValorCerto">{{ requisicaoEfSefa.percentual }}</p>
                                        <p v-if="requisicaoEfSefa.boletoValorCerto">Boleto Valor Certo</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Calculado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoEfSefa.valorCalculado }}</p>
                                    </b-col>
                                </b-row>

                                <hr class="mt-4"/>

                                <b-row class="mt-1 mb-0">
                                    <b-col>
                                        <label>CDA (EF) - Valor de Base (VB) - Honorários (% aplicado):</label>
                                    </b-col>
                                </b-row>

                                <b-row class="mb-0 overflow-grid-extrato">
                                    <b-col md="12" style="padding-left: 30px;" v-for="cda in requisicaoEfSefa.cdas">
                                        <label>{{cda}}</label>
                                    </b-col>
                                </b-row>

                                <b-button
                                        id="btnRelatorioDeducoes"
                                        class="ml-2"
                                        variant="outline-warning"
                                        style="height: 40px;float: right;margin-top: 10px;"
                                        @click="relatorioDeducoesPDF()"
                                        v-if="requisicaoEfSefa.possuiDeducoes">
                                    <i class="fa fa-eye"></i> Ver Relatório de Deduções
                                </b-button>
                                <b-button
                                        id="btnRelatorioDeducoesSem"
                                        class="ml-2"
                                        variant="outline-warning"
                                        style="height: 40px;float: right;margin-top: 10px;"
                                        v-b-modal.modal-alerta-deducoes-ef-sefa
                                        v-if="!requisicaoEfSefa.possuiDeducoes">
                                    <i class="fa fa-eye"></i> Ver Relatório de Deduções
                                </b-button>
                            </b-tab>
                            <b-tab title="Pagamento(s)" title-link-class="text-title" v-if="requisicaoEfSefa.status != 'Encaminhada CES'">
                                <b-row sm="12" md="12" class="d-block">
                                    <b-button class="mr-2" variant="outline-warning" @click="anteciparBoleto" :disabled="(requisicaoEfSefa.mesFechado ? true : (requisicaoEfSefa.possuiIndiceAtualizado ? false : anteciparParcelaBloqueado()))"
                                        :title="'O botão Antecipar Parcelas faz com que sejam antecipadas as parcelas futuras, sendo gerado um único boleto abrangendo o valor de todas as parcelas vincendas com data de vencimento para o último dia útil do mês corrente.'
                                        + (!requisicaoEfSefa.possuiIndiceAtualizado ? '\r\nO Índice de Reajuste das parcelas utilizado na emissão desta Requisição ainda não conta com variação cadastrada para o mês anterior ao mês atual. Aguarde o cadastro da variação ou entre em contato com os administradores do sistema.'
                                        : '')
										+ (requisicaoEfSefa.mesFechado    ? '\r\nRequisição à vista, cancelada ou com boleto emitido e ainda não pago/vencido. Aguarde a solução do boleto (pagamento/vencimento) para gerar a antecipação das parcelas restantes.': '')"
																					
                                    >
                                        <i class="fa fa-money-check-alt"></i> Antecipar Parcelas
                                    </b-button>
                                    <b-button class="mr-2" variant="outline-warning"
                                              @click="abrirModalRescindirParcelamento"
                                              :disabled="requisicaoCancelada() || requisicaoEfSefa.tipoPagamento == 'À Vista' || !requisicaoEmDiaAtrasado()"
                                        title="O botão Rescindir Parcelamento faz com que o parcelamento seja rescindido, bem como cancelados todos os boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos)."
                                    >
                                        <i class="fa fa-ban"></i> Rescindir Parcelamento
                                    </b-button>
                                    <b-button variant="outline-primary" @click="enviarEmail" class="mr-2"
                                        :title="`Enviar boleto e documentação ao devedor`"
                                    >
                                        <i class="far fa-envelope"></i> Enviar por E-mail
                                    </b-button>
                                    <b-button variant="secondary" v-b-modal.modal-cancelar-ef-sefa :disabled="desabilitarCancelarEditar()" class="float-right"
                                        title="O botão Cancelar a Requisição permite o cancelamento da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. No caso de parcelamento com parcelas pagas, utilize o botão Rescindir Parcelamento disponível na aba Pagamento(s)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar a Requisição
                                    </b-button>
                                    <b-button variant="warning" class="mr-2 float-right" @click="alterarHonorarios" :disabled="desabilitarCancelarEditar()" v-if="exibirEditar"
                                        title="O botão Editar a Requisição permite editar os parâmetros da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. Para a Requisição no status Pendente, caso a edição acarrete a alteração do seu valor, da data de vencimento ou do devedor, o boleto anteriormente gerado na sua criação será automaticamente cancelado, bem como emitido novo boleto com os dados corretos ao final da edição."
                                    >
                                        <i class="fa fa-pen"></i> Editar a Requisição
                                    </b-button>
                                </b-row>
                                <b-row class="text-right mt-3">
                                    <b-button v-show="exibirEditar" class="mr-2" variant="outline-secondary" @click="cancelarBoleto" :disabled="requisicaoCancelada()"
                                        title="O botão Cancelar Boleto faz com que sejam cancelados todos os boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar Boleto
                                    </b-button>
                                    <b-button v-show="exibirEditar" class="mr-2" variant="outline-primary" @click="gerarBoleto" :disabled="!requisicaoEfSefa.possuiIndiceAtualizado || requisicaoCancelada()"
                                        :title="'O botão Gerar Boleto faz com que sejam cancelados todos os eventuais boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos) e gerados novos boletos para todas as parcelas pendentes e para a parcela do mês corrente.'
                                            + (requisicaoCancelada() || requisicaoEfSefa.possuiIndiceAtualizado ? '' : '\r\nO Índice de Reajuste das parcelas utilizado na emissão desta Requisição ainda não conta com variação cadastrada para o mês anterior ao mês atual. Aguarde o cadastro da variação ou entre em contato com os administradores do sistema.')"
                                    >
                                        <i class="fa fa-file-pdf"></i> Gerar Boleto
                                    </b-button>
                                </b-row>
                                <b-row class="mt-3 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Boleto(s) Gerado(s):</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0 overflow-grid-extrato">
                                    <b-table
                                            id="pagamentos"
                                            ref="tablePagamentos"
                                            :items="parcelasTemp"
                                            :fields="fieldsParcelas"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhuma parcela encontrada.</p>
                                        </template>
                                        <template v-slot:head(codigoBarras)="{ item }">
                                            Código de Barras <i class="filter" :class="!isEmpty(filtrosParcela.codigoBarras) || filtrosParcela.filtrarCodigoBarras == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Código de Barras', 'texto', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataGeracao)="{ item }">
                                            Data Geração <i class="filter" :class="!isEmpty(filtrosParcela.dataGeracao) || filtrosParcela.filtrarDataGeracao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Geração', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataVencimento)="{ item }">
                                            Data Venc. <i class="filter" :class="!isEmpty(filtrosParcela.dataVencimento) || filtrosParcela.filtrarDataVencimento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Vencimento', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataPagamento)="{ item }">
                                            Data Pgto <i class="filter" :class="!isEmpty(filtrosParcela.dataPagamento) || filtrosParcela.filtrarDataPagamento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Pgto', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(valor)="{ item }">
                                            Valor <i class="filter" :class="!isEmpty(filtrosParcela.valor) || filtrosParcela.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Valor', 'numerico', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(situacao)="{ item }">
                                            Situação <i class="filter" :class="!isEmpty(filtrosParcela.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Situação', 'checkbox', dados.listaSituacaoParcela, null, $event)"></i>
                                        </template>
                                        <template v-slot:cell(codigoBarras)="{ item }">
                                            <b-link @click="buscarPdfBoleto(item)" target="_blank">{{ item.codigoBarras }}</b-link>
                                        </template>
                                        <template v-slot:cell(valor)="{ item }">
                                            {{ item.valor | currency }}
                                        </template>
                                    </b-table>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click=hide()> <i class="fa fa-reply"></i> Voltar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-cancelar-ef-sefa"
                id="modal-cancelar-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cancelar a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja cancelar a requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar-ef-sefa')"> Não</b-button>
                <b-button variant="primary" @click="cancelarRequisicao"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-alerta-deducoes-ef-sefa"
                id="modal-alerta-deducoes-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Requisição sem pagamentos anteriores deduzidos"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>A presente Requisição foi gerada sem a dedução de pagamentos anteriores.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-alerta-deducoes-ef-sefa')"> Voltar</b-button>
            </template>
        </b-modal>

	    <b-modal
		    ref="modal-rescindir-ef"
		    id="modal-rescindir-ef"
		    size="xl"
		    :content-class="'shadow ' + getTheme"
		    title="Rescindir a Requisição"
		    header-bg-variant="success"
		    header-text-variant="white">
		    <b-row class="mt-3">
			    <b-col xs="12" md="12" class="mx-auto">
				    <p style="font-weight: bold;">Deseja rescindir o parcelamento formalizado através desta requisição?</p>
			    </b-col>
		    </b-row>
		    <template v-slot:modal-footer="{ hide }">
			    <b-button variant="secondary" @click="hide('modal-rescindir-ef')"> Não</b-button>
			    <b-button variant="primary" class="btn-sim-rescindir-ef" @click="rescindirParcelamento"> Sim</b-button>
		    </template>
	    </b-modal>

        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="loading"
                @salvarDevedor="salvarDevedor"/>

        <ModalEnviarEmail
                ref="modalEnviarEmail"
                :anexos="requisicaoEfSefa.anexos"
                :loading="loading"
                @enviarEmail="enviarEmail"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ModalEnviarEmail from "../../shared/components/ModalEnviarEmail"
    import CompFiltroGrid from "../../shared/components/CompFiltroGrid"

    export default {
    props: ['loading'],
    components: { ModalAlterarDevedor, ModalEnviarEmail, CompFiltroGrid },
    mixins: [ formatarMixins ],
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            idRequisicao: null,
            exibirEditar: false,
            perfilAdministrador: false,
            tabIndex: 0,
            dados: {
                uf: [],
                municipios: [],
                tiposPagamento: [],
                listaSituacaoParcela: []
            },
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            requisicaoEfSefa: {
                id: null,
                numeroRequisicao: null,
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                modalidadeParcelamento: null,
                quantidadeParcelas: null,
                valor: null,
                percentualPago: null,
                indiceReajuste: null,
                setor: null,
                refis: null,
                quitada: null,
                observacoes: null,
                baseCalculo: null,
                valorBase: null,
                percentual: null,
                valorCalculado: null,
                total: null,
                bloquearBotoesBoletoMesAnterior: null,
                titularReceita: null,
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                },
                cdas: [],
                parcelas: [],
                anexos: [],
            },
            fieldsParcelas: [
                {
                    key: 'numeroParcela',
                    label: 'Parc.'
                },
                {
                    key: 'codigoBarras',
                    label: 'Código de Barras'
                },
                {
                    key: 'dataGeracao',
                    label: 'Data Geração'
                },
                {
                    key: 'dataVencimento',
                    label: 'Data Venc.'
                },
                {
                    key: 'dataPagamento',
                    label: 'Data Pgto'
                },
                {
                    key: 'valor',
                    label: 'Valor'
                },
                {
                    key: 'situacao',
                    label: 'Situação'
                }
            ],
            parcelasTemp: [],
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                campoTexto: null,
                campoData: null,
                campoRadio: null,
                campoCheckbox: null,
                listaValores: []
            },
            filtrosParcela: {
                filtrarCodigoBarras: null,
                codigoBarras: null,
                filtrarDataGeracao: null,
                dataGeracao: null,
                filtrarDataVencimento: null,
                dataVencimento: null,
                filtrarDataPagamento: null,
                dataPagamento: null,
                filtrarValor: null,
                valor: null,
                situacao: null
            }
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
    },
    methods: {
        abrirExtrato(item) {
            this.limparMsgsModal();

            this.idRequisicao = item.id;

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/carregarExtrato/${item.tabelaOrigem}/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemCarregado = item;
                this.requisicaoEfSefa = response.data;
                this.pagamentosReduzidosTemp = [];
                this.parcelasTemp = [];
                this.requisicaoEfSefa.parcelas.forEach(el => {
                    this.parcelasTemp.push(el);
                });
                this.$refs['modal-honorarios-ef-sefa'].show();

                setTimeout(()=>{
                    var tabelas = document.getElementsByClassName("tabelaModal");
                    for (let i = 0; i < tabelas.length; i++) {
                        var inner = tabelas[i].children[0].children[0];
                        inner.style.position = 'sticky';
                        inner.style.top = '-2px';
                    }
                }, 200);
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async obterAnexo(anexo) {
            if(anexo.codAnexo == null) {
                await axios.get(`${this.urlApi}/v1/pesquisas/downloadTermoParcelamento/${this.requisicaoEfSefa.tipoOrigem}/${this.idRequisicao}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                }).then(response => {
                    if(!response.data || !response.data.byteLength){
                        this.messageModal = {
                            message: 'Arquivo não encontrado para download.',
                            variant: 'danger'
                        }
                        return;
                    }

                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = anexo.nomeAnexo;
                    link.click();
                }).catch((error) => {
                    this.exibirErro(error)
                });
            } else {
                await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                }).then(response => {
                    if(!response.data || response.data == null){
                        this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                        return;
                    }

                    var a = document.createElement("a");
                    a.href = response.data.base64;
                    a.download = response.data.nomeArquivo;
                    a.click();
                }).catch((error) => {
                    this.exibirErro(error)
                });
            }
        },

        async relatorioPDF() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarRequisicaoEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'requisicaoEfSefa' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        cancelarBoleto() {
            this.limparMsgsModal();

            let parcelas = [];
            for(var i = 0; i < this.requisicaoEfSefa.parcelas.length; i++) {
                if(this.requisicaoEfSefa.parcelas[i].situacao == 'Pendente') {
                    parcelas.push(this.requisicaoEfSefa.parcelas[i].codParcela);
                }
            }

            if(parcelas.length == 0) {
                this.messageModal = {
                    message: 'Não existe parcela para ser cancelada',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/boleto/bancobrasil/cancelamento/cancelar/${this.requisicaoEfSefa.titularReceita}`, parcelas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(() => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcela cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

	    abrirModalRescindirParcelamento() {
		    this.showModal('modal-rescindir-ef');
	    },

        rescindirParcelamento() {

	        this.hideModal('modal-rescindir-ef');
            this.updated = true;
            this.limparMsgsModal();

            if((this.requisicaoEfSefa.status != 'Em dia' &&
                this.requisicaoEfSefa.status != 'Atrasada')
                || (this.requisicaoEfSefa.quantidadeParcelas == null || this.requisicaoEfSefa.quantidadeParcelas <= 1)) {
                this.messageModal = {
                    message: 'Requisição não pode ser Rescindida.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/rescindirRequisicaoEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcela rescindida com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        anteciparBoleto() {
            this.limparMsgsModal();
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/anteciparParcelasRequisicaoEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Não existe boleto a ser gerado',
                        variant: 'danger'
                    };
                    return;
                }
                this.updated = true;
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Boleto' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
                this.abrirExtrato(this.itemCarregado);
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        buscarPdfBoleto (item) {
            this.limparMsgsModal()
            this.loading.showLoading()
            axios.get(`${this.urlApi}/v1/pesquisas/boleto/download/${item.codParcela}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if (!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Boleto não encontrado',
                        variant: 'danger'
                    }
                    return
                }

                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Boleto' + (item.codigoBarras ? item.codigoBarras : 'boleto') + '.pdf'
                link.click()
            }).catch((error) => {
                this.messageModal = {
                    message: 'Boleto não encontrado',
                    variant: 'danger'
                }
                return
            }).finally(() => {
                this.loading.hideLoading()
            })
        },

        gerarBoleto() {
            this.limparMsgsModal();
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/gerarBoletoRequisicaoEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Não existe boleto a ser gerado',
                        variant: 'danger'
                    };
                    return;
                }
                this.updated = true;
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Boleto' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
                this.abrirExtrato(this.itemCarregado);
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        cancelarRequisicao() {
            this.$refs['modal-cancelar-ef-sefa'].hide();
            this.limparMsgsModal();

            if(this.requisicaoEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoEfSefa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser cancelada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/cancelarRequisicaoEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Requisição cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        alterarHonorarios() {
            this.limparMsgsModal();

            if(this.requisicaoEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoEfSefa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser alterada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            if(this.$router.currentRoute.fullPath.startsWith('/honorarios-ef-sefa')) {
                this.$emit('obterRequisicaoEfSefa', this.itemCarregado.id, false);
                this.$refs['modal-honorarios-ef-sefa'].hide();
            } else {
                this.$store.commit('setRequisicaoEfSefa', this.itemCarregado.id);
                this.$router.push({path: '/honorarios-ef-sefa'});
            }
        },

        atualizarCadastro() {
            this.$refs.modalAlterarDevedor.atualizarCadastro(this.requisicaoEfSefa.contribuinte);
        },
        enviarEmail () {
            this.$refs.modalEnviarEmail.abrirModalEnviarEmail(this.requisicaoEfSefa)
        },
        incluirAnexo () {
            this.$refs['incluir-anexo'].$el.childNodes[0].click()
        },
        realizarUpload (arquivo) {
            this.$store.commit("setMessages", {});
            let arquivoConvertido = null
            if ((arquivo.size / 1024) / 1024 > 50.0) {
                this.messageModal = {
                    message: 'Tamanho do arquivo ultrapassa o limite definido em 50mb.',
                    variant: 'danger'
                };
            } else {
                var reader = new FileReader()
                reader.onload = function (e) {
                    arquivoConvertido = {
                        nomeArquivo: arquivo.name,
                        base64: e.target.result
                    }
                }
                reader.readAsDataURL(arquivo)
                reader.onloadend = () => this.salvarAnexo(arquivoConvertido)
            }
        },
        salvarAnexo (arquivo) {
            let parametros = {
                id: this.requisicaoEfSefa.id,
                arquivo: arquivo,
                tipoOrigem: this.requisicaoEfSefa.tipoOrigem
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/incluirAnexo`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                let codAnexo = ((response) && (response.data)) ? response.data.id : 0
                this.requisicaoEfSefa.anexos.push({
                    codAnexo: codAnexo,
                    nomeAnexo: arquivo.nomeArquivo,
                    base64 : arquivo.base64
                })
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        removerAnexo (arquivo) {
            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/removerAnexo/${arquivo.codAnexo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.requisicaoEfSefa.anexos = this.requisicaoEfSefa.anexos.filter((anexo) => anexo.codAnexo !== arquivo.codAnexo)
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        salvarDevedor(contribuinte) {
            this.requisicaoEfSefa.contribuinte = {
                codContribuinte: contribuinte.codContribuinte,
                nome: contribuinte.nome,
                documento: contribuinte.documento,
                telefone: contribuinte.telefone,
                telefoneAlternativo1: contribuinte.telefoneAlternativo1,
                telefoneAlternativo2: contribuinte.telefoneAlternativo2,
                email: contribuinte.email,
                emailAlternativo1: contribuinte.emailAlternativo1,
                emailAlternativo2: contribuinte.emailAlternativo2,
                cep: contribuinte.cep,
                logradouro: contribuinte.logradouro,
                numero: contribuinte.numero,
                complemento: contribuinte.complemento,
                bairro: contribuinte.bairro,
                uf: contribuinte.uf,
                municipio: contribuinte.municipio
            };
            this.messageModal = {
                message: 'Cadastro do Devedor alterado com sucesso!',
                variant: 'success'
            };
            this.updated = true;
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        close() {
            this.$emit('closeModal', this.updated);
            this.updated = false;
        },
        requisicaoCancelada() {
            return this.requisicaoEfSefa != null && (this.requisicaoEfSefa.status == 'Cancelada' || this.requisicaoEfSefa.status == 'Quitada' || this.requisicaoEfSefa.status == 'Rescindido');
        },
        anteciparParcelaBloqueado() {
            return this.requisicaoCancelada() || this.requisicaoEfSefa.tipoPagamento == 'À Vista' || !this.requisicaoEmDiaAtrasado();
        },
        requisicaoEmDiaAtrasado() {
            return this.requisicaoEfSefa != null && (this.requisicaoEfSefa.status == 'Em dia' || this.requisicaoEfSefa.status == 'Atrasada');
        },
        desabilitarCancelarEditar() {
            return this.requisicaoEfSefa != null && this.requisicaoEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoEfSefa.status != 'Pendente';
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        openFilterPopup(campo, tipo, values, mascara, event) {
            if(document.getElementById('popupExtrato').style.display == 'block'
                && this.filtro.campoFiltro == campo) {
                this.$refs.compFiltro.closeFilterPopup();
            } else {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'Código de Barras') {
                    this.filtro.filtrarEm = this.filtrosParcela.filtrarCodigoBarras;
                    this.filtro.campoTexto = this.filtrosParcela.codigoBarras;
                } else if(this.filtro.campoFiltro == 'Data Geração') {
                    this.filtro.filtrarEm = this.filtrosParcela.filtrarDataGeracao;
                    this.filtro.campoData = this.filtrosParcela.dataGeracao;
                } else if(this.filtro.campoFiltro == 'Data Pgto') {
                    this.filtro.filtrarEm = this.filtrosParcela.filtrarDataPagamento;
                    this.filtro.campoData = this.filtrosParcela.dataPagamento;
                } else if(this.filtro.campoFiltro == 'Data Vencimento') {
                    this.filtro.filtrarEm = this.filtrosParcela.filtrarDataVencimento;
                    this.filtro.campoData = this.filtrosParcela.dataVencimento;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.filtro.filtrarEm = this.filtrosParcela.filtrarValor;
                    this.filtro.campoTexto = this.filtrosParcela.valor;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtro.campoCheckbox = this.filtrosParcela.situacao;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                if(this.tabIndex == 2) {
                    this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 405);
                } else {
                    this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 245);
                }
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            this.filtrosParcela.codRequisicao = this.requisicaoEfSefa.id;
            this.filtrosParcela.tipoOrigem = this.requisicaoEfSefa.tipoOrigem;
            if(this.filtro.campoFiltro == 'Código de Barras') {
                this.filtrosParcela.filtrarCodigoBarras = this.filtro.filtrarEm;
                this.filtrosParcela.codigoBarras = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Data Geração') {
                this.filtrosParcela.filtrarDataGeracao = this.filtro.filtrarEm;
                this.filtrosParcela.dataGeracao = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Data Pgto') {
                this.filtrosParcela.filtrarDataPagamento = this.filtro.filtrarEm;
                this.filtrosParcela.dataPagamento = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Data Vencimento') {
                this.filtrosParcela.filtrarDataVencimento = this.filtro.filtrarEm;
                this.filtrosParcela.dataVencimento = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Valor') {
                this.filtrosParcela.filtrarValor = this.filtro.filtrarEm;
                this.filtrosParcela.valor = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Situação') {
                this.filtrosParcela.situacao = this.filtro.campoCheckbox;
            }

            this.consultarParcelas();
        },
        ordenarResultados(order) {
            let campoOrdenacao;
            this.filtrosParcela.codRequisicao = this.requisicaoEfSefa.id;
            this.filtrosParcela.tipoOrigem = this.requisicaoEfSefa.tipoOrigem;
            if(this.filtro.campoFiltro == 'Código de Barras') {
                campoOrdenacao = 'parcela.linhaDigitavel';
            } else if(this.filtro.campoFiltro == 'Data Geração') {
                campoOrdenacao = 'parcela.dataHoraEmissao';
            } else if(this.filtro.campoFiltro == 'Data Pgto') {
                campoOrdenacao = 'parcela.dataHoraBaixaBanco';
            } else if(this.filtro.campoFiltro == 'Data Vencimento') {
                campoOrdenacao = 'parcela.dataVencimento';
            } else if(this.filtro.campoFiltro == 'Valor') {
                campoOrdenacao = 'parcela.valorPago';
            } else if(this.filtro.campoFiltro == 'Situação') {
                campoOrdenacao = 'parcela.situacao';
            }

            this.consultarParcelas(campoOrdenacao, order);
        },
        async consultarParcelas(campoOrdenacao, order) {
            let ordenacao = '';
            if (campoOrdenacao != null && order != null) {
                ordenacao = `?sortField=${campoOrdenacao}&sortOrder=${order}`;
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/pesquisas/consultarParcelas${ordenacao}`, this.filtrosParcela, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.parcelasTemp = response.data;
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        async listarSituacaoParcela() {
            axios.get(`${this.urlApi}/v1/boletoNaoEncontrado/listarSituacaoParcela`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.listaSituacaoParcela = response.data;
            })
        },
        async relatorioDeducoesPDF() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarDeducoes/${this.requisicaoEfSefa.tipoOrigem}/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'requisicaoEfSefa' + this.itemCarregado.numeroRequisicao + '.pdf';
                    link.click();
                }).finally(() => {
                this.loading.hideLoading();
            })
        },
	    acionarEnter(e) {
		    if(e.key == 'Enter' && this.$refs['modal-rescindir-ef'].isShow) {
			    this.rescindirParcelamento();
		    }
	    },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR' || userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.exibirEditar = true;
                }
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.perfilAdministrador = true;
                }
            }
        }

        this.listarTiposPagamento();
        this.listarSituacaoParcela();

	    setTimeout(()=>{
		    window.addEventListener("keypress", this.acionarEnter);
	    }, 500);
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
